import React, { useState } from 'react'
import { StyledTable } from 'components/TableStyles/TableStyles'
import {
  RowNumberData,
  Wrapper,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import ActionDropdown from 'modules/Users/Partials/UsersTable/ActionDropdown'
import ViewUserRoleDrawer from 'modules/Users/Partials/ViewUserRoleDrawer'
import Pagination from 'components/Pagination'
import UserStatus from 'modules/Users/Partials/UsersTable/UserStatus'
import { EmptyWrapper } from 'modules/Users/Style/style'
import { Empty, Spin } from 'antd'

const UsersTable = ({
  userList,
  userRole,
  setSortBy,
  loading,
  getSingleUserInfo,
  singleUserData,
  setAddUserDrawer,
  setUserId,
  updateUserStatus,
  deleteUser,
  setPageNum,
  getUserData,
  pageNum,
  updateLoading,
}) => {
  const [viewUserDrawer, setViewUserDrawer] = useState(false)

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?._id === id)[0]?.name
    return roleName || '-'
  }

  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }

  const onPageChange = num => {
    setPageNum(num)
  }

  const columns = [
    {
      title: 'user',
      dataIndex: 'user',
      key: 'first_name',
      render: (_, rowData) => (
        <RowNumberData>
          {rowData?.first_name} {rowData?.last_name}
        </RowNumberData>
      ),
    },
    {
      title: 'user role',
      dataIndex: 'role_id',
      key: 'role_id',
      render: rowData => <RowNumberData>{getRoleName(rowData)}</RowNumberData>,
    },
    {
      title: 'corporates',
      dataIndex: 'email',
      key: 'email',
      render: rowData => rowData,
    },
    {
      title: 'institutes',
      dataIndex: 'email',
      key: 'email',
      render: rowData => rowData,
    },
    {
      title: 'status',
      dataIndex: 'status',
      key: 'status',
      render: (status, rowData) =>
        rowData?.is_active === true || rowData?.is_active === false ? (
          <UserStatus status={rowData?.is_active} />
        ) : (
          '-'
        ),
    },
    {
      title: 'Action',
      dataIndex: '_id',
      width: 150,
      render: (id, rowData) => (
        <ActionDropdown
          rowData={rowData}
          setViewUserDrawer={setViewUserDrawer}
          getSingleUserInfo={getSingleUserInfo}
          setAddUserDrawer={setAddUserDrawer}
          setUserId={setUserId}
          updateUserStatus={updateUserStatus}
          deleteUser={deleteUser}
          getUserData={getUserData}
        />
      ),
    },
  ]

  return (
    <>
      <Wrapper>
        <StyledTable
          columns={columns}
          pagination={false}
          dataSource={userList?.list}
          onChange={onSorting}
          locale={{
            emptyText: (
              <EmptyWrapper center isSpin={loading}>
                {!loading ? <Empty description={'No user found!'} /> : <Spin />}
              </EmptyWrapper>
            ),
          }}
        />

        <Pagination
          onChange={onPageChange}
          totalPages={userList?.count}
          pageSize={10}
          current={pageNum}
        />
      </Wrapper>

      <ViewUserRoleDrawer
        viewUserDrawer={viewUserDrawer}
        setViewUserDrawer={setViewUserDrawer}
        singleUserData={singleUserData}
        getRoleName={getRoleName}
        updateLoading={updateLoading}
      />
    </>
  )
}

export default UsersTable
